/**
 * axios global instance
 * setting default valiue ( baseUrl, headers < session > )
 * catch Error
 */
import axios from "axios";

const baseURL = "https://teacher.schooltogether.kr/api/manager";
// process.env.NODE_ENV === "development"
//     ? "http://192.168.0.13:3000/manager"
//     : "https://teacher.schooltogether.kr/api/manager";

const axiosInstance = axios.create({
    baseURL,
    headers: {
        "Content-Type": "application/json"
    }
});

axiosInstance.interceptors.request.use(
    function(config) {
        return config;
    },
    function(error) {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    function(response) {
        const {
            data: { result, data, code }
        } = response;

        if (!data) {
            return response.data;
        }

        if (result === "fail") throw code;

        return data === undefined ? result : data;
    },
    function(error) {
        return Promise.reject(error);
    }
);

export default axiosInstance;
